import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphqlService } from '../http/graphql.service';
import { NativeStorageService } from '../storage/native-storage.service';

@Injectable({
  providedIn: 'root',
})
export class OfferService {

  public shouldAskForLead = true;

  public offers = [];

  public productNameDict = {
    ELEVADOR_DE_ALCALINIDADE: 'Elevador de Alcalinidade',
    CLORO: 'Cloro',
    PASTILHA_DE_TRICLORO: 'Pastilha de tricloro',
    DECANTADOR: 'Decantador',
    ALGICIDA_DE_CHOQUE: 'Algicida de Choque',
    ALGICIDA_DE_MANUTENCAO: 'Algicida de Manutenção',
    ACIDO_REDUTOR_DE_PH: 'Ácido/Redutor de ph',
    BARRILHA: 'Barrilha',
  };

  private offersQuery = gql`
    {
      offers {
        id
        createdAt
        link
        classification
      }
    }
  `;

  constructor(
    private nativeStorage: NativeStorageService,
    private graphqlService: GraphqlService,
  ) { }

  public async init() {
    await this.nativeStorage.getItem('shouldAskForLead')
      .catch(() => true)
      .then((shouldAskForLead) => this.shouldAskForLead = shouldAskForLead);
    await this.loadOffers();
    await this.fetchOffers();
  }

  public setShouldAskForLead(shouldAskForLead) {
    this.shouldAskForLead = shouldAskForLead;
    return this.nativeStorage.save('shouldAskForLead', this.shouldAskForLead);
  }

  public async fetchOffers() {
    const offers = await this.graphqlService.query(this.offersQuery);
    this.saveOffers(offers.offers);
    return offers;
  }

  private async loadOffers() {
    return this.nativeStorage.getItem('offers')
      .catch(() => [])
      .then((offers) => {
        this.offers = offers;
        return offers;
      });
  }

  private saveOffers(offers) {
    this.offers = offers;
    this.nativeStorage.save('offers', this.offers);
  }

}
